import Alpine from "alpinejs";
import { rafTimeOut } from "./requestAnimationFrame";

document.addEventListener("alpine:init", () => {
    Alpine.store("access", {
        user: Alpine.$persist(false).as("access_user"),
        mandate: Alpine.$persist(false).as("access_mandate"),
        async update() {
            const response = await fetch("/api/voyeur.json");
            if (response.ok) {
                const data = await response.json();
                this.user = data.user;
                this.mandate = data.mandate;
            }
        },
        init() {
            // We let the browser wait a bit to reduce load
            rafTimeOut(() => {
                this.update();
            }, 500);
        },
    });

    window.addEventListener("loginSuccessfull", () => {
        Alpine.store("access").update();
    });
});
